var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-game-instructions",attrs:{"id":"instructions"}},[_c('Task',{attrs:{"taskNumber":_vm.taskNumber,"task":_vm.task,"taskExtraDescription":_vm.taskExtraDescription}}),_vm._v(" "),_c('TaskDescription',{attrs:{"description":_vm.taskDescription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }